import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, COMPANY } from "@/lib/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center group"
          data-testid="nav-logo-link"
          onClick={() => setOpen(false)}
        >
          <img
            src="/logo.png"
            alt="IVrenovation and Construction"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link text-sm font-semibold tracking-wide uppercase ${
                  isActive ? "text-zinc-900" : "text-zinc-600 hover:text-zinc-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={COMPANY.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-zinc-700 hover:text-orange-600 transition"
            data-testid="nav-phone-link"
          >
            {COMPANY.phone}
          </a>
          <Link
            to="/contact"
            className="bg-orange-600 hover:bg-orange-700 text-white px-5 py-3 text-sm font-bold uppercase tracking-wider transition"
            data-testid="nav-cta-button"
          >
            Get a Quote
          </Link>
        </div>

        <button
          className="md:hidden p-2 text-zinc-900"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base font-semibold uppercase tracking-wide ${
                    isActive ? "text-orange-600" : "text-zinc-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="bg-orange-600 text-white px-5 py-3 text-sm font-bold uppercase tracking-wider text-center"
              data-testid="nav-mobile-cta"
            >
              Get a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
